<rt-report-parameters
    [controlNames]="controlNames"
    (getReport)="onGetReportClick($event)"
    (cancelReport)="onCancelClick()"
>
</rt-report-parameters>
<div *ngIf="displayReport">
    <dx-data-grid
        bds-grid
        id="bdsReportGrid"
        [dataSource]="gridSource"
        height="80vh"
        minHeight="200px"
        (onContentReady)="onContentReady($event)"
    >
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxi-column dataField="route_detail" caption="Route Detail"></dxi-column>
        <dxi-column
            dataField="NO_OF_TRIPS"
            caption="No.of Trips"
            sortOrder="desc"
            [sortIndex]="0"
        ></dxi-column>
        <dxi-column dataField="route_code" caption="Route Code"></dxi-column>
        <dxi-column dataField="route_dscr" caption="Route Dscr"></dxi-column>
        <dxi-column caption="Origin">
            <dxi-column dataField="origin_city" caption="City"></dxi-column>
            <dxi-column dataField="origin_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column caption="Destination">
            <dxi-column dataField="dest_city" caption="City"></dxi-column>
            <dxi-column dataField="dest_state" caption="State"></dxi-column>
        </dxi-column>
        <dxi-column dataField="dlv_road" caption="Dlv Carrier"></dxi-column>
        <dxi-column caption="Outbound" alignment="center">
            <dxi-column dataField="OUT_ACT_HRS" caption="Act Hrs"></dxi-column>
            <dxi-column dataField="eta_hrs_out" caption="ETA Hrs"></dxi-column>
            <dxi-column
                dataField="OUT_VAR_HRS"
                caption="Var Hrs"
                cellTemplate="varianceCellTemplate"
            ></dxi-column>
        </dxi-column>
        <dxi-column caption="Inbound" alignment="center">
            <dxi-column dataField="IN_ACT_HRS" caption="Act Hrs"></dxi-column>
            <dxi-column dataField="eta_hrs_in" caption="ETA Hrs"></dxi-column>
            <dxi-column
                dataField="IN_VAR_HRS"
                caption="Var Hrs"
                cellTemplate="varianceCellTemplate"
            ></dxi-column>
        </dxi-column>
        <dxi-column
            dataField="TOTAL_VAR_HRS"
            caption="Total Var Hrs"
            cellTemplate="varianceCellTemplate"
        ></dxi-column>

        <div
            *dxTemplate="let cellInfo of 'varianceCellTemplate'"
            [class.negative-number-class]="cellInfo.value != null && cellInfo.value < 0"
        >
            {{ cellInfo.value }}
        </div>
    </dx-data-grid>
    <div style="text-align: right; padding: 10px; font-weight: bold">
        Total Count: {{ totalCount }}
    </div>
</div>
